import RegisterPage from "../../features/authentication/register/register-page";

export default function Register() {
  return <RegisterPage />;
}
